import { CartProductUI } from './CartProductUI';
import { useEffectiveEquivalenceCharges } from '../../../user/application/useEffectiveEquivalenceCharges';
import { calculateDiscountPercentage } from '../../../helpers/calculateDiscountPercentage';
import { useCartContext } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';
export const CartProduct = ({ product, isDeprecated = false, displayQuantity, packParentName }) => {
  const { changeEquivalenceCharges, removeProduct, updateReceta, loadEspecies } = useCartContext();
  const equivalenceCharges = useEffectiveEquivalenceCharges();
  const navigate = useNavigate();

  const editProduct = (product) => {
    navigate(`/articulos/${encodeURIComponent(product.code)}`);
  };

  return (
    <CartProductUI
      data={{
        product: product,
        productDiscount: product && calculateDiscountPercentage(product.basePrice, product.sellingPrice),
        promotionDiscount: product?.promotionDiscount ?? 0,
        userEquivalenceCharges: equivalenceCharges,
        isDeprecated: isDeprecated,
        displayQuantity: displayQuantity,
        packParentName: packParentName
      }}
      actions={{
        changeProductEquivalenceCharges: () => changeEquivalenceCharges(product),
        updateReceta: updateReceta,
        loadEspecies: loadEspecies,
        edit: () => editProduct(product),
        remove: () => removeProduct(product)
      }}
    />
  );
};